import React from 'react';
import PropTypes from 'prop-types';
import sharedStyle from '../layout.module.scss';
import style from './layout-c.module.scss';

export const LayoutC = props => {
    const { mainContent, children, classes, heroContent, narrow } = props;

    return (
        <>
            {heroContent}
            <div className={`site-width layout ${narrow ? style.narrow : ''}`}>
                <div className={`${sharedStyle.layoutInner} ${classes}`}>
                    {children}
                    <main className={`${sharedStyle.main}`}>{mainContent}</main>
                </div>
            </div>
        </>
    );
};

LayoutC.propTypes = {
    mainContent: PropTypes.node.isRequired,
    heroContent: PropTypes.node,
    classes: PropTypes.string,
    narrow: PropTypes.bool
};

LayoutC.defaultProps = {
    heroContent: null,
    classes: '',
    narrow: false
};
